import styled from 'styled-components'

export const ScrollContainer = styled.section``
